import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CatalogoRequest } from 'src/app/modal/catalogo/catalogo-request';
import { CatalogoResponse } from 'src/app/modal/catalogo/catalogo-response';
import { CarritoService } from 'src/app/service/carrito/carrito.service';
import { NovedadesService } from 'src/app/service/catalogo/novedades.service';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { environment } from 'src/environments/environment';
import { ProtectedImageService } from 'src/app/service/catalogo/protected-image.service';
import { ProtectedImageResponse } from 'src/app/modal/catalogo/protected-image-response';

@Component({
  selector: 'app-fotografias',
  templateUrl: './fotografias.component.html',
  styleUrls: ['./fotografias.component.scss']
})
export class FotografiasComponent implements OnInit {
  listFotografias:CatalogoResponse;
  flgAgregar:string = "0";

  // nlpr ini
  columnas = [[], [], []];
  // nlpr fin

  protectedImages: Map<string, ProtectedImageResponse> = new Map();
  private imageUrlCache: Map<string, string | null> = new Map();
  private imageLoadStartTimes: Map<string, number> = new Map();
  private imageReadyForDisplay: Map<string, boolean> = new Map();
  public isSkeletonVisible: Map<string, boolean> = new Map();
  private imageOrientations: Map<string, string> = new Map();

  constructor(private novedadesService:NovedadesService,
    private usuarioService:UsuarioService,
    private carritoService:CarritoService,
    private router : Router,
    private utilitarioService:UtilitarioService,
    private protectedImageService: ProtectedImageService
    ) { }

  buscarFotografias(){
    this.clearProtectedImagesCache(); // Limpiar cache antes de nueva búsqueda
    let catalogoRequest:CatalogoRequest;
    catalogoRequest = new CatalogoRequest();
    this.listFotografias = new CatalogoResponse();
    catalogoRequest.authorId="0";
    catalogoRequest.categoryId="0";
    catalogoRequest.categoryName="FOTOGRAFIAS";
    catalogoRequest.page="1";
    catalogoRequest.subCategoryId="0";
    catalogoRequest.subCategoryName="";
    catalogoRequest.publicationId="0";
    catalogoRequest.size="6";
    catalogoRequest.title="";
    catalogoRequest.yearId="0";

    this.novedadesService.buscarCatalogo(catalogoRequest).subscribe(data=>{
      // console.log("fotografia",data);
      if(data.response.codeResponse=="0000"){
        this.listFotografias = data;

        // Cargar tokens para las imágenes de la página actual
        this.loadTokensForCurrentPage();

        // nlpr ini
        this.listFotografias.response.list.forEach((fila, index) => {
          const columnaIndex = index % 3;  // Determina en qué columna irá el elemento
          this.columnas[columnaIndex].push(fila);
          // Cargar imagen protegida para cada elemento
          this.loadProtectedThumbnail(fila.activoId);
        });
        // nlpr fin

      }
    })
  }
  imagen(img:String){   
    return img.replace(/_=2?/,"");
  }
  onComprar(id){
    if(this.usuarioService.obtenerSesionUsuario()){
      let idLibro = id;
      let cantidad = "1";
      let tipoProducto = "1";
      let sizeID ="0";
      let libroArray = {};
      cantidad = "1";
      this.carritoService.obtenerCantidadCarrito();    
      libroArray ={id:idLibro,cantidad:cantidad,tipoProducto:tipoProducto,sizeID:sizeID,modalidadId:1};
      //si agrega y limpio el carrito
      if((this.flgAgregar == "1") && ( this.carritoService.cantidadCarrito == 0)){
        this.carritoService.obtenerCantidadCarrito();
        this.carritoService.agregarCarrito(libroArray);
        this.router.navigate(['/procesarpago']);
        return;
      }
      //si no agrega, adiciona automaticamente al carrito
      if(this.flgAgregar == "0"){
        this.carritoService.obtenerCantidadCarrito();
        this.carritoService.agregarCarrito(libroArray);
        this.router.navigate(['/procesarpago']);
        return;
      }
      //si flag es 1 y no entra en las 2 condiciiones anteriores
      this.router.navigate(['/procesarpago']);
    }
    else{
      this.utilitarioService.toastrWarning("Necesita iniciar sesión");
    }
  }
  buscarConsulta(idCategoria,idSubCategoria){
    this.novedadesService.idCategoria=idCategoria;
    this.novedadesService.idSubCategoria=idSubCategoria;
    // nlpr ini
    if (idCategoria==1){
      this.router.navigateByUrl('/fotografias/'+this.generaNss());
    }else{
      this.router.navigateByUrl('/consultas/'+this.generaNss());
    }
    // nlpr fin
  }
  generaNss(){
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < charactersLength; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  /**
   * Genera un slug amigable desde el título
   */
  generateSlug(title: string): string {
    if (!title) return 'd';

    return title
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Eliminar acentos
      .replace(/[^a-z0-9\s-]/g, '') // Eliminar caracteres especiales
      .trim()
      .replace(/\s+/g, '-') // Reemplazar espacios con guiones
      .replace(/-+/g, '-') // Reemplazar múltiples guiones con uno solo
      .substring(0, 100) || 'd'; // Limitar longitud y fallback
  }

  loadProtectedThumbnail(imageId: string): void {
    if (!imageId) {
      return;
    }

    // Evitar múltiples peticiones para la misma imagen
    if (this.protectedImages.has(imageId)) {
      return; // Ya está siendo procesada o ya existe
    }

    // console.log('🔄 Cargando imagen de inicio fotografías:', imageId);

    // Marcar como en proceso para evitar duplicados
    this.protectedImages.set(imageId, {
      imageId: imageId,
      protectedThumbnailUrl: null,
      expiresIn: 0,
      loadedAt: Date.now()
    });

    this.protectedImageService.getProtectedThumbnail(imageId).subscribe({
      next: (response) => {
        response.loadedAt = Date.now();
        this.protectedImages.set(imageId, response);
        // Actualizar cache de URL
        this.imageUrlCache.set(imageId, response.protectedThumbnailUrl);

        // Calcular orientación basada en metadatos PRIMERO
        if (response.metadata && response.metadata.width && response.metadata.height) {
          const width = parseInt(String(response.metadata.width));
          const height = parseInt(String(response.metadata.height));
          const ratio = width / height;

          if (Math.abs(ratio - 1) < 0.1) {
            this.imageOrientations.set(imageId, 'square');
          } else if (height > width) {
            this.imageOrientations.set(imageId, 'portrait');
          } else {
            this.imageOrientations.set(imageId, 'landscape');
          }
        } else {
          // Por defecto landscape para fotografías
          this.imageOrientations.set(imageId, 'landscape');
        }

        // DESPUÉS de calcular orientación, mostrar skeleton si aún no se ha iniciado
        if (!this.imageLoadStartTimes.has(imageId)) {
          this.imageLoadStartTimes.set(imageId, Date.now());
        }

        // Calcular tiempo transcurrido desde que inició la carga
        const startTime = this.imageLoadStartTimes.get(imageId) || Date.now();
        const elapsedTime = Date.now() - startTime;
        const minimumDelay = 800; // 800ms mínimo para apreciar el skeleton

        // Siempre esperar el tiempo mínimo completo
        const timeToWait = Math.max(0, minimumDelay - elapsedTime);

        setTimeout(() => {
          this.isSkeletonVisible.set(imageId, false);
          this.imageReadyForDisplay.set(imageId, true);
          //console.log(`🖼️ Mostrando imagen de inicio fotografías después de ${minimumDelay}ms:`, imageId);
        }, timeToWait);

        //console.log('✅ Token recibido para inicio fotografías:', imageId);
      },
      error: (error) => {
        console.error('❌ Error cargando imagen de inicio fotografías:', imageId, error);
        // Remover de la lista en caso de error para permitir reintento
        this.protectedImages.delete(imageId);
        this.imageLoadStartTimes.delete(imageId);
        this.isSkeletonVisible.delete(imageId);
      }
    });
  }

  // Cargar tokens de forma inteligente para elementos visibles
  loadTokensForCurrentPage(): void {
    if (!this.listFotografias?.response?.list) return;

    const currentPageItems = this.listFotografias.response.list;
    // console.log('Cargando tokens para', currentPageItems.length, 'fotografías de la página actual');

    currentPageItems.forEach(item => {
      if (item.activoId) {
        this.loadProtectedThumbnail(item.activoId);
      }
    });
  }

  getProtectedImageUrl(imageId: string): string | null {
    if (!imageId) {
      return null;
    }

    // Si el skeleton está visible, no mostrar imagen aún
    if (this.isSkeletonVisible.get(imageId)) {
      return null;
    }

    // Si ya no está el skeleton, devolver la URL desde el cache
    return this.imageUrlCache.get(imageId) || null;
  }

  // Método público para el template
  shouldShowSkeleton(imageId: string): boolean {
    if (!imageId) return false;

    // Solo mostrar skeleton si ya se calculó la orientación
    if (!this.imageOrientations.has(imageId)) {
      return false; // No mostrar nada hasta que se calcule orientación
    }

    // Si nunca se ha iniciado la carga del skeleton, iniciarlo ahora
    if (!this.imageLoadStartTimes.has(imageId)) {
      this.imageLoadStartTimes.set(imageId, Date.now());
      this.isSkeletonVisible.set(imageId, true);
      return true;
    }

    return this.isSkeletonVisible.get(imageId) || false;
  }

  // Obtener clase de orientación para el skeleton
  getSkeletonOrientationClass(imageId: string): string {
    const orientation = this.imageOrientations.get(imageId);
    if (orientation === 'portrait') {
      return 'skeleton-portrait';
    } else if (orientation === 'square') {
      return 'skeleton-landscape'; // o crear skeleton-square si es necesario
    }
    return 'skeleton-landscape'; // Por defecto
  }

  clearProtectedImagesCache(): void {
    // console.log('Limpiando cache de imágenes protegidas para nueva carga');
    this.protectedImages.clear();
    this.imageUrlCache.clear();
    this.imageLoadStartTimes.clear();
    this.imageReadyForDisplay.clear();
    this.isSkeletonVisible.clear();
    this.imageOrientations.clear();
  }

  ngOnInit(): void {
    this.clearProtectedImagesCache(); // Limpiar cache al inicializar
    this.buscarFotografias();
  }

  ngAfterViewInit(): void {
    // Agregar event listeners para efecto holográfico después de que la vista se inicialice
    setTimeout(() => {
      this.addHolographicEffectListeners();
    }, 500);
  }

  addHolographicEffectListeners(): void {
    // Seleccionar CARDS completos (no solo contenedores de imagen)
    const cardsWeb = document.querySelectorAll('.panelFotografiaWeb');
    const cardsMovil = document.querySelectorAll('.panelFotografiaMovil');

    // Aplicar listeners a versión web (card completo)
    cardsWeb.forEach((card: HTMLElement) => {
      const imageContainer = card.querySelector('.imagen-container-holografico') as HTMLElement;
      const marcoContainer = card.querySelector('.marco-container') as HTMLElement;

      if (imageContainer) {
        this.applyHolographicListenersToCard(card, imageContainer, marcoContainer);
      }
    });

    // Aplicar listeners a versión móvil (card completo)
    cardsMovil.forEach((card: HTMLElement) => {
      const imageContainer = card.querySelector('.imagen-container-holografico') as HTMLElement;
      const marcoContainer = card.querySelector('.marco-container') as HTMLElement;

      if (imageContainer) {
        this.applyHolographicListenersToCard(card, imageContainer, marcoContainer);
      }
    });
  }

  private applyHolographicListenersToCard(card: HTMLElement, imageContainer: HTMLElement, marcoContainer: HTMLElement | null): void {
    // Función para manejar el movimiento del mouse sobre el CARD
    const handleMove = (e: MouseEvent | TouchEvent) => {
      let clientX: number, clientY: number;

      if (e instanceof MouseEvent) {
        clientX = e.clientX;
        clientY = e.clientY;
      } else if (e.touches && e.touches.length > 0) {
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
      } else {
        return;
      }

      // Obtener posición relativa al contenedor de imagen
      const rect = imageContainer.getBoundingClientRect();
      const x = ((clientX - rect.left) / rect.width) * 100;
      const y = ((clientY - rect.top) / rect.height) * 100;

      imageContainer.style.setProperty('--mouse-x', `${x}%`);
      imageContainer.style.setProperty('--mouse-y', `${y}%`);

      // Efecto 3D siguiendo el mouse (aplicado al marco completo)
      if (marcoContainer) {
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const mouseX = clientX - rect.left;
        const mouseY = clientY - rect.top;

        const rotateX = ((mouseY - centerY) / centerY) * -10;
        const rotateY = ((mouseX - centerX) / centerX) * 10;

        marcoContainer.classList.add('imagen-3d');
        marcoContainer.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      }
    };

    // Función para resetear efectos
    const handleEnd = () => {
      if (marcoContainer) {
        marcoContainer.classList.remove('imagen-3d');
        marcoContainer.style.transform = '';
      }
      imageContainer.style.setProperty('--mouse-x', '50%');
      imageContainer.style.setProperty('--mouse-y', '50%');
    };

    // Eventos de mouse en el CARD
    card.addEventListener('mousemove', handleMove as EventListener);
    card.addEventListener('mouseleave', handleEnd);

    // Eventos táctiles en el CARD
    let touchStartX = 0;
    let touchStartY = 0;
    let hasMoved = false;

    card.addEventListener('touchstart', (e: TouchEvent) => {
      hasMoved = false;
      if (e.touches.length > 0) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        imageContainer.classList.add('touch-active');
        handleMove(e);
      }
    }, { passive: true });

    card.addEventListener('touchmove', (e: TouchEvent) => {
      if (e.touches.length > 0) {
        const deltaX = Math.abs(e.touches[0].clientX - touchStartX);
        const deltaY = Math.abs(e.touches[0].clientY - touchStartY);

        if (deltaX > 10 || deltaY > 10) {
          hasMoved = true;
          e.preventDefault();
          handleMove(e);
        }
      }
    });

    card.addEventListener('touchend', () => {
      imageContainer.classList.remove('touch-active');
      handleEnd();
      hasMoved = false;
    }, { passive: true });
  }

  // Calcular dimensiones proporcionales para la imagen
  getImageDimensions(width: string, height: string, maxWidth: number = 161): { width: number, height: number } {
    const originalWidth = parseInt(width) || 161;
    const originalHeight = parseInt(height) || 256;

    // Calcular aspect ratio
    const aspectRatio = originalWidth / originalHeight;

    // Calcular nuevas dimensiones manteniendo el aspect ratio
    const newWidth = maxWidth;
    const newHeight = Math.round(maxWidth / aspectRatio);

    return { width: newWidth, height: newHeight };
  }

}
